<template>
<div class="content-page">
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="page-title-box">
                    <h4 class="page-title">입실자 관리 / {{ currentMonth }}월</h4>
                </div>
            </div>
            <div class="row mb-3" v-if="kosiwonList.length > 0">
                <div class="col-auto">
                    <div class="form-floating">
                        <select class="form-select" style="padding-bottom: 0.125rem;" v-model="selectedKosiwon" @change="fetchRoom()">
                            <option v-for="(kosiwon, idx) in kosiwonList" :key="`kosiwon_${idx}`" :value="kosiwon">
                                <strong>{{ computedKosiwonName(kosiwon) }}</strong>
                            </option>
                        </select>
                        <label>고시원 목록</label>
                    </div>
                </div>
                <div class="col-auto ms-auto mt-2" v-if="roomList.length > 0">
                    <div class="d-flex justify-content-end">
                        <div class="btn-group d-sm-inline-block">
                            <button type="button" class="btn" :class="gridClass" @click="changeView(true)">
                                <i class="mdi mdi-view-grid-outline"></i>
                            </button>
                        </div>
                        <div class="btn-group d-sm-inline-block">
                            <button type="button" class="btn" :class="listClass" @click="changeView(false)">
                                <i class="mdi mdi-format-list-checkbox"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-2" v-if="roomList.length > 0">
                <div class="col-auto me-n1">
                    <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">입실 상태 / {{ statusType.text }} </button>
                    <div class="dropdown-menu">
                        <a v-for="(option, idx) in statusType_Options" :key="`status_${idx}`" class="dropdown-item" :class="{'fw-bold': option.value === statusType.value}" @click="changeStatusType(option.value)">
                            {{ option.text }}
                            <i class="mdi mdi-check-bold" v-if="option.value === statusType.value">&nbsp;</i>
                        </a>
                    </div>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">수납 현황 / {{ payType.text }}</button>
                    <div class="dropdown-menu">
                        <a v-for="(option, idx) in payType_Options" :key="`status_${idx}`" class="dropdown-item" :class="{'fw-bold': option.value === payType.value}" @click="changePayType(option.value)">
                            {{ option.text }}
                            <i class="mdi mdi-check-bold" v-if="option.value === payType.value">&nbsp;</i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-2">
                            <h4>
                                {{ computedKosiwonName(selectedKosiwon) }}
                                <span v-if="filteredRoomList.length > 0">({{ filteredRoomList.length }}개)</span>
                            </h4>
                        </div>
                        <div class="row" v-if="loading"></div>
                        <template v-else>
                            <div class="row">
                                <div class="card mb-0" v-if="kosiwonList.length <= 0">
                                    <div class="card-body">
                                        <div class="text-center">
                                            <img src="assets/images/svg/file-searching.svg" height="140" alt="File not found Image">
                                            <h3 class="mt-4">등록된 고시원이 존재하지 않습니다.</h3>
                                            <p class="text-muted mt-3">실제 운영중이신 고시원을 등록해보세요!<br />체계화된 입실자 관리 서비스를 이용하실 수 있습니다.</p>
                                            <button type="button" class="btn btn-outline-info fw-bold mt-1" @click="goToKosiwonList()">
                                                고시원 등록하기
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <template v-else>
                                    <template v-if="roomList.length > 0">
                                        <!-- GRID VIEW -->
                                        <template v-if="IS_GRID_VIEW">
                                            <template v-if="filteredRoomList.length > 0">
                                                <div class="col-md-6 col-xxl-4" v-for="(room, idx) in filteredRoomList" :key="`room_grid_${idx}_${room.pk}`">
                                                    <GuestBox :room="room" :today="today" :idx="idx" @open-register-modal="openRegisterModal" @open-view-modal="openViewModal" @open-paid-modal="openPaidModal" @toggle-payment="togglePayment" @open-del-modal="openDelModal" />
                                                </div>
                                            </template>
                                            <div class="card mb-0" v-else>
                                                <div class="card-body">
                                                    <div class="text-center">
                                                        <img src="assets/images/svg/file-searching.svg" height="140" alt="File not found Image">
                                                        <p class="text-muted mt-3">{{ computedKosiwonName(selectedKosiwon) }} 지점에<br />선택한 카테고리에 대한 데이터가 존재하지 않습니다.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- LIST VIEW -->
                                        <div class="table-responsive" v-else>
                                            <table class="table table-centered table-nowrap text-center mb-0">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th style="width:30px;">
                                                            <input type="checkbox" id="selectAllCheckbox">
                                                        </th>
                                                        <th style="width: 150px;">방 호실</th>
                                                        <th style="width: 150px;">입실 상태</th>
                                                        <th style="width: 150px;">이름</th>
                                                        <th style="width: 150px;">{{ currentMonth }}월 수납</th>
                                                        <th style="width: 150px;">계약 기간</th>
                                                        <th style="width: 150px;">거주일 / 예약일</th>
                                                        <th style="width: 150px;">남은일 / 공실일</th>
                                                        <th style="width: 150px;">수납일</th>
                                                        <th style="width: 150px;">월 수납 금액</th>
                                                        <th style="width: 150px;">휴대폰 번호</th>
                                                        <th style="width: 150px;">추가 / 상세 / 수정 / 삭제</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="filteredRoomList.length > 0 ">
                                                    <GuestRow v-for="(room, idx) in filteredRoomList" :key="`room_list_${idx}_${room.pk}`" :room="room" :today="today" :idx="idx" @open-register-modal="openRegisterModal" @open-view-modal="openViewModal" @open-paid-modal="openPaidModal" @toggle-payment="togglePayment" @open-del-modal="openDelModal" />
                                                </tbody>
                                                <tbody style="text-align:center;" v-else>
                                                    <tr>
                                                        <td colspan="15" class="py-5">
                                                            <div class="text-center">
                                                                <img src="assets/images/svg/file-searching.svg" height="140" alt="File not found Image">
                                                                <p class="text-muted mt-3">{{ computedKosiwonName(selectedKosiwon) }} 지점에<br />선택한 카테고리에 대한 데이터가 존재하지 않습니다.</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>
                                    <div class="card mb-0" v-else>
                                        <div class="card-body">
                                            <div class="text-center">
                                                <img src="assets/images/svg/file-searching.svg" height="140" alt="File not found Image">
                                                <h3 class="mt-4">{{ computedKosiwonName(selectedKosiwon) }} 지점에 등록된 방이 존재하지 않습니다.</h3>
                                                <p class="text-muted mt-3">실제 운영중이신 방을 등록해보세요!<br />체계화된 입실자 관리 서비스를 이용하실 수 있습니다.</p>
                                                <button type="button" class="btn btn-outline-info fw-bold mt-1" @click="goToRoomList()">
                                                    방 등록하기
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <GuestRegisterModal :kosiwon_name="computedKosiwonName(selectedKosiwon)" :room="room" :guest="guest" :isEdit="isEdit" @open-confirm-modal="openConfirmModal" />

    <GuestRegisterConfirmModal :kosiwon_name="computedKosiwonName(selectedKosiwon)" :room_name="room.name" :guest="payload" :isEdit="isEdit" @save-guest="saveGuest" />

    <GuestViewModal :kosiwon_name="computedKosiwonName(selectedKosiwon)" :room_name="room.name" :guest="guest_view" :today="today" @open-paid-modal="openPaidModal" />

    <GuestPaidModal :guest="guest_view" :payment="payment" @none-payment="nonePayment" @open-paid-confirm-modal="openPaidConfirmModal" />

    <GuestPaidConfirmOverModal @save-payment="savePayment" />

    <GuestPaidConfirmUnderModal @save-payment="savePayment" />

    <GuestDeleteConfirmModal @del-guest="delGuest" />
</div>
</template>

<script>
import {
    MONTH_DIFF,
    IS_DATE_IN_RANGE
} from "@/config/date.js";

import {
    REG_EXP
} from "@/config/const.js";

import common from "@/mixins/common.js";

import GuestBox from "@/components/guest/GuestBox";
import GuestRow from "@/components/guest/GuestRow";
import GuestRegisterModal from "@/components/modal/GuestRegister";
import GuestRegisterConfirmModal from "@/components/modal/GuestRegisterConfirm";
import GuestViewModal from "@/components/modal/GuestView";

import GuestPaidModal from "@/components/modal/GuestPaid";
import GuestPaidConfirmOverModal from "@/components/modal/GuestPaidOverConfirm";
import GuestPaidConfirmUnderModal from "@/components/modal/GuestPaidUnderConfirm";

import GuestDeleteConfirmModal from "@/components/modal/GuestDeleteConfirm";

import dayjs from "dayjs";

export default {
    components: {
        GuestBox,
        GuestRow,
        GuestRegisterModal,
        GuestRegisterConfirmModal,
        GuestViewModal,
        GuestPaidModal,
        GuestPaidConfirmOverModal,
        GuestPaidConfirmUnderModal,
        GuestDeleteConfirmModal
    },
    mixins: [
        common
    ],
    data() {
        return {
            IS_GRID_VIEW: true,

            loading: true,
            today: dayjs(),
            currentMonth: dayjs().format("YYYY-MM"),

            isEdit: false,

            target_guest_pk: "",

            kosiwonList: [],
            roomList: [],
            room: {},

            guest: {}, // 게스트 생성 시
            payload: {}, // 게스트 생성 시, 가공 후
            guest_view: {}, // 게스트 view
            payment: {},

            init_guest: {
                name: "",
                phone_no: "",
                gender: "M",
                birth_date: null,
                job: "N",
                is_foreigner: false,
                country_name: "",
                address: "",

                start_date: null,
                end_date: null,

                price: 0,
                deposit: 0,
                maintenance_price: 0,
                month_pay_date: 1,
                vat: null,
                non_payment_month: 0,

                guest_payment: []
            },

            statusType: {
                value: "all",
                text: "전체"
            },
            statusType_Options: [{
                    value: "all",
                    text: "전체"
                },
                {
                    value: "entrance",
                    text: "입실"
                },
                {
                    value: "waiting",
                    text: "예약"
                },
                {
                    value: "expired",
                    text: "공실"
                }
            ],

            payType: {
                value: "all",
                text: "전체"
            },
            payType_Options: [{
                    value: "all",
                    text: "전체"
                },
                {
                    value: true,
                    text: "수납"
                },
                {
                    value: false,
                    text: "미납"
                }
            ],
        }
    },
    beforeRouteLeave(to, from, next) {
        $(".modal").modal("hide");
        next();
    },
    computed: {
        gridClass() {
            return this.IS_GRID_VIEW ? "btn-secondary" : "text-muted";
        },
        listClass() {
            return this.IS_GRID_VIEW ? "text-muted" : "btn-secondary";
        },
        selectedKosiwon: {
            set(value) {
                this.$store.commit("SET_SELECTED_KOSIWON", value);
            },
            get() {
                return this.$store.state.selectedKosiwon;
            }
        },
        filteredRoomList() {
            return this.roomList.filter(room => {
                // 입실 상태 필터링
                const statusMatch = this.statusType.value === "all" || room.recent_guest.status === this.statusType.value;

                // 수납 상태 필터링
                const paymentMatch = this.payType.value === "all" || room.recent_guest.is_checked === this.payType.value;

                // 상태와 수납 필터링을 모두 만족하는 방만 반환
                return statusMatch && paymentMatch;
            });
        },
        totalPrice() {
            const price = this.guest_view.price || 0;
            const maintenance = this.guest_view.maintenance_price || 0;
            let total = price + maintenance;

            if (this.guest_view.vat === "vat_price") {
                total = (price * 1.1) + maintenance;
            } else if (this.guest_view.vat === "vat_all") {
                total = (price + maintenance) * 1.1;
            }

            return Number.isInteger(total) ? total : total.toFixed(1);
        },
        inputTotalPrice() {
            const paid_price = this.payment.paid_price || 0;
            const paid_maintenance_price = this.payment.paid_maintenance_price || 0;
            const paid_vat = this.payment.paid_vat || 0;

            let total = paid_price + paid_maintenance_price + paid_vat;
            return Number.isInteger(total) ? total : total.toFixed(1);
        }
    },
    async mounted() {
        try {
            const kosiwon = await this.axios.get("/kosiwon");

            this.kosiwonList = kosiwon.data.result;

            if (this.kosiwonList.length > 0) {
                this.$store.commit("SET_SELECTED_KOSIWON", this.selectedKosiwon.pk ? this.selectedKosiwon : this.kosiwonList[0]);

                this.initModalZindex("guest-modal", "register-confirm-modal");
                this.initModalZindex("guest-view-modal", "guest-paid-modal");
                this.initModalZindex("guest-paid-modal", "guest-paid-under-confirm-modal");
                this.initModalZindex("guest-paid-modal", "guest-paid-over-confirm-modal");

                this.fetchRoom();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setTimeout(() => {
                this.loading = false;
            }, 200);
        }
    },
    methods: {
        goToKosiwonList() {
            this.$router.push({
                path: "/kosiwon/list"
            });
        },
        initModalZindex(parentId, childId) {
            $(`#${childId}`).on("show.bs.modal", () => {
                $(`#${parentId}`).css("z-index", "1050");
            });

            $(`#${childId}`).on("hidden.bs.modal", () => {
                $(`#${parentId}`).css("z-index", "1055");
            });
        },
        computedKosiwonName(kosiwon) {
            return `${kosiwon.name} ${kosiwon.branch}`;
        },
        changeView(flag) {
            if (this.IS_GRID_VIEW !== flag) {
                this.IS_GRID_VIEW = !this.IS_GRID_VIEW;
            }
        },
        changeStatusType(value) {
            const selectedOption = this.statusType_Options.find(option => option.value === value);
            if (selectedOption && this.statusType.value !== selectedOption.value) {
                this.statusType = selectedOption;
            }
        },
        changePayType(value) {
            const selectedOption = this.payType_Options.find(option => option.value === value);
            if (selectedOption && this.payType.value !== selectedOption.value) {
                this.payType = selectedOption;
            }
        },
        async fetchRoom() {
            try {
                this.statusType = {
                    value: "all",
                    text: "전체"
                };
                this.payType = {
                    value: "all",
                    text: "전체"
                };

                const room = await this.axios.get(`/getWithGuestAndPayment/${this.selectedKosiwon.pk}`);

                room.data.result.forEach(room => {
                    room.recent_guest = this.checkGuestStatus(room.guest);
                });

                this.roomList = room.data.result;
                console.log(this.roomList);
            } catch (error) {
                console.log(error);
            } finally {
                setTimeout(() => {
                    this.loading = false;
                }, 200);
            }
        },
        checkGuestStatus(guest) {
            if (guest.length <= 0) {
                return {
                    ...this.init_guest,
                    status: "expired",
                    pay_btn_view: false,
                    is_checked: false
                };
            }

            const today = this.today.startOf("day");
            const target_guest = guest[0];

            const startDate = dayjs(target_guest.start_date);
            const endDate = target_guest.end_date ? dayjs(target_guest.end_date) : null;

            // 입실일이 오늘 이후인 경우 ("waiting" 상태)
            if (today.isBefore(startDate)) {
                return {
                    ...target_guest,
                    status: "waiting",
                    pay_btn_view: true,
                    is_checked: false
                };
            }

            // 퇴실일이 오늘 이전인 경우 ("expired" 상태)
            if (!endDate || today.isBetween(startDate, endDate, null, "[]")) {

                // this.checkPayStatus(target_guest, today);

                return {
                    ...target_guest,
                    status: "entrance",
                    pay_btn_view: true,
                    is_checked: false
                };
            }

            // 기본적으로는 expired로 설정
            return {
                ...target_guest,
                status: "expired",
                pay_btn_view: false,
                is_checked: false
            };
        },
        goToRoomList() {
            this.$router.push({
                path: "/room/list"
            });
        },
        openRegisterModal(room, isEdit = false) {
            this.room = room;
            this.isEdit = isEdit;

            if (this.isEdit) {
                this.guest = {
                    kosiwon_pk: this.selectedKosiwon.pk,
                    room_pk: this.room.pk,
                    ...this.room.recent_guest
                };
            } else {
                this.guest = {
                    kosiwon_pk: this.selectedKosiwon.pk,
                    room_pk: this.room.pk,
                    ...this.init_guest
                };
            }

            $("#guest-modal").modal("show");
        },
        openViewModal(room) {
            this.room = room;

            this.guest_view = {
                ...room.recent_guest
            };

            $("#guest-view-modal").modal("show");
        },
        openPaidModal(payment) {
            this.payment = {
                ...payment
            };

            $("#guest-paid-modal").modal("show");
        },
        setFocus(id) {
            document.getElementById(id).focus();
        },
        createPayload(data) {
            const payload = {
                ...this.guest
            };

            payload.maintenance_price = payload.maintenance_price || 0;
            payload.deposit = payload.deposit || 0;

            payload.address = data.address;
            payload.job = data.job === "other" ? data.input_job : data.job;
            payload.country_name = payload.is_foreigner ? $("#country").val() : "";

            payload.today = this.today;

            return payload;
        },
        openConfirmModal(data) {

            if (this.guest.name.trim() === "") {
                alert("입실자 이름을 입력해주세요.");
                this.guest.name = "";
                this.setFocus("name");
                return;
            }

            if (!REG_EXP.PHONE.test(this.guest.phone_no)) {
                alert("올바른 휴대폰 번호를 입력해주세요.")
                this.setFocus("phone_no");
                return;
            }

            if (this.guest.price === "" || this.guest.price <= 0) {
                alert("월 임대료에 금액을 입력해주세요.\n0보다 커야합니다.");
                this.setFocus("price");
                return;
            }

            if (!this.guest.start_date) {
                alert("계약 시작일을 선택해주세요.");
                this.setFocus("start_date_input");
                return;
            }

            if (!data.end_date_checked && !this.guest.end_date) {
                alert("계약 종료일을 선택해주세요.\n계약 종료일이 불분명할 때, 미지정을 선택해 주세요.");
                this.setFocus("end_date_input");
                return;
            }

            if (this.guest.start_date > this.guest.end_date) {
                alert("계약 시작일이 계약 종료일보다 클 수 없습니다.\n다시 한 번 계약일을 확인해주세요.");
                return;
            }

            // console.log(this.guest.start_date);
            // console.log(this.guest.end_date);
            // console.log(this.today)

            // * 계약 종료일이 미정일 경우 오늘을 기준으로 설정
            const month_diff = MONTH_DIFF(this.guest.start_date, this.guest.end_date || this.today.format("YYYY-MM-DD"));

            // * alert text 수정해야함. (종료일이 null일 경우 멘트 변경)
            if (this.guest.non_payment_month > month_diff) {
                alert(`입력한 임대료 미납 개월 수(${this.guest.non_payment_month}개월)가 총 계약기간 개월 수(${month_diff}개월)를 초과합니다.\n다시 한번 확인해 주세요.`);
                return;
            }

            /** 
                // end_date의 값이 존재 (즉 계약 종료일이 미지정이 아닐 때)
                const condition_1 = !!this.guest.end_date;
    
                // month_diff가 1달 보다 작을 때
                const condition_2 = month_diff < 1;
    
                // month_pay_date(임대료 수납일)이 start_date, end_date에 포함되지 않을 때
                // IS_DATE_IN_RANGE(params1, params2, params2) => params1,2 날짜 사이에 특정일이 속해 있는지 check하는 함수
                const condition_3 = !IS_DATE_IN_RANGE(this.guest.start_date, this.guest.end_date, this.guest.month_pay_date);
    
                if (condition_1 && condition_2 && condition_3) {
                    alert(`총 계약기간 개월 수가 1달 미만일 경우, 임대료 수납일이 계약일 내에 포함되어 있어야 합니다.`);
                    return;
                }
                **/

            if (data.job === "other" && data.input_job === "") {
                alert("입실자 직업에 기타를 선택한 경우 직업을 입력해주세요.");
                this.setFocus("input_job");
                return;
            }

            this.payload = this.createPayload(data);
            $("#register-confirm-modal").modal("show");
        },
        async saveGuest() {
            if (this.isEdit) {
                try {
                    this.loadingOverlay(true);
                    await this.axios.put(`/guest/${this.payload.pk}`, this.payload);
                    alert("계약이 정상적으로 수정되었습니다.");
                } catch (error) {
                    console.log(error);
                    alert("계약 수정 중 예기치 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
                } finally {
                    this.loadingOverlay(false);
                    this.$router.go();
                }
            } else {
                try {
                    this.loadingOverlay(true);
                    await this.axios.post("/guest", this.payload);
                    alert("계약이 정상적으로 등록되었습니다.");
                } catch (error) {
                    console.log(error);
                    alert("계약 등록 중 예기치 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
                } finally {
                    this.loadingOverlay(false);
                    this.$router.go();
                }
            }

        },
        openDelModal(room) {
            this.target_guest_pk = room.recent_guest.pk;
            $("#guest-delete-modal").modal("show");
        },
        async delGuest() {
            try {
                this.loadingOverlay(true);

                await this.axios.delete(`/guest/${this.target_guest_pk}`);
                alert("정상적으로 삭제가 완료 되었습니다");
            } catch (error) {
                console.log(error);
                alert("입실자 삭제 중 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.loadingOverlay(false);
                this.$router.go();
            }
        },
        togglePayment(room, payment, is_checked) {
            this.room = room;

            this.guest_view = {
                ...room.recent_guest
            };

            this.payment = {
                ...payment
            };

            if (is_checked) {
                this.openPaidModal(payment);
            } else {
                this.nonePayment();
            }
        },
        openPaidConfirmModal() {
            if (this.inputTotalPrice > this.totalPrice) {
                $("#guest-paid-over-confirm-modal").modal("show");
            } else if (this.inputTotalPrice < this.totalPrice) {
                $("#guest-paid-under-confirm-modal").modal("show");
            } else {
                this.savePayment();
            }
        },
        savePayment(flag = null) {
            let target = this.guest_view.guest_payment.find(item => item.pk === this.payment.pk);

            let paid_status = "PAID_COMPLETE";
            let color = "rgba(var(--ct-success-rgb), 0.8)";

            if (flag === "over") {
                color = "rgba(var(--ct-primary-rgb), 0.8)"
            } else if (flag === "under") {
                paid_status = "PAID_NONE";
                color = "rgba(var(--ct-warning-rgb), 0.8)"
            }

            const updatedPayment = {
                ...target,
                paid_status: paid_status,
                paid_price: this.payment.paid_price,
                paid_maintenance_price: this.payment.paid_maintenance_price,
                paid_vat: this.payment.paid_vat,
                paid_total: this.inputTotalPrice,
                paid_at: this.payment.paid_at,
                memo: this.payment.memo
            };

            this.axios.put(`/guest_payment/${target.pk}`, updatedPayment).then(() => {
                this.showToastAlarm({
                    title: `${this.room.name} ${this.guest_view.name}`,
                    sub_title: `${this.payment.paid_year_month}월 / ${this.inputTotalPrice}만원 수납 처리 완료`,
                    color: color
                });

                if (this.currentMonth === updatedPayment.paid_year_month) {
                    this.updatePayment(true);
                }

                Object.assign(target, updatedPayment); // 객체 복사
            }).catch(err => {
                console.log(err);
                this.showToastAlarm({
                    title: `${this.room.name} ${this.guest_view.name}`,
                    sub_title: "미납 처리 중, 오류가 발생하였습니다.<br/>다시 시도해주세요.",
                    color: "rgba(var(--ct-danger-rgb), 0.8)"
                });
            }).finally(() => {
                $("#guest-paid-modal").modal("hide");
                $("#guest-paid-over-confirm-modal").modal("hide");
                $("#guest-paid-under-confirm-modal").modal("hide");
            });
        },
        nonePayment() {
            let target = this.guest_view.guest_payment.find(item => item.pk === this.payment.pk);

            const updatedPayment = {
                ...target,
                paid_status: "PAID_NONE",
                paid_price: 0,
                paid_maintenance_price: 0,
                paid_vat: 0,
                paid_total: 0,
                paid_at: null
            };

            this.axios.put(`/guest_payment/${target.pk}`, updatedPayment).then(() => {
                this.showToastAlarm({
                    title: `${this.room.name} ${this.guest_view.name}`,
                    sub_title: `${target.paid_year_month}월 / ${target.paid_total}만원 미납 처리`,
                    color: "rgba(var(--ct-danger-rgb), 0.8)"
                });

                if (this.currentMonth === updatedPayment.paid_year_month) {
                    this.updatePayment(false);
                }

                Object.assign(target, updatedPayment); // 객체 복사
            }).catch(err => {
                console.log(err);
                this.showToastAlarm({
                    title: `${this.room.name} ${this.guest_view.name}`,
                    sub_title: "미납 처리 중, 오류가 발생하였습니다.<br/>다시 시도해주세요.",
                    color: "rgba(var(--ct-danger-rgb), 0.8)"
                });
            }).finally(() => {
                $("#guest-paid-modal").modal("hide");
            });
        },
        updatePayment(flag) {
            this.room.recent_guest.is_checked = flag;
        },
        showToastAlarm(msg) {
            $.toast({
                heading: msg.title,
                text: msg.sub_title,
                bgColor: msg.color,
                loaderBg: "rgba(0, 0, 0, 0.2)",
                position: "bottom-center",
                loader: true,
                hideAfter: 2000
            });
        }
    }
}
</script>
